import { css } from '@emotion/react'
import styled from '@emotion/styled'

import type { Theme } from 'scripts/react-components/themes/Theme'

export const Button = styled('strong')(
  ({ theme }: Theme) => css`
    font-size: 14px;
    font-family: 'Segoe UI', Arial;
    line-height: 24px;
    background: ${theme.colors.p500};
    padding: 10px 14px;
    border-radius: 30px;
    cursor: pointer;
    white-space: nowrap;

    &.active {
      color: white;
      font-weight: bold;
    }
  `
)

export const Menu = styled('div')(
  () => css`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: white;
    z-index: 1000;
    display: flex;
    overflow-x: auto;

    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  `
)

export const MenuContainer = styled('div')(
  () => css`
    margin: 0 auto;
    padding: 10px;
    display: flex;
    gap: 10px;

    @media (max-width: 768px) {
      padding: 10px 20px;
      flex-wrap: nowrap;
    }
  `
)

export const Home = styled('div')(
  () => css`
    height: 750px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  `
)
